export default "__VITE_ASSET__Cf3Fonb6__"